/** Triggers a browser download of in-memory content as `fileName`. */
export function downloadBlob(
  fileName: string,
  content: BlobPart,
  type: string,
): void {
  const url = URL.createObjectURL(new Blob([content], { type }));
  downloadUrl(fileName, url);
  URL.revokeObjectURL(url);
}

export function downloadUrl(fileName: string, url: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
}
